// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"f25e7fb5","364":"c2dedfff","388":"af3a7501","411":"cfbc878d","421":"dbe0816c","544":"30b76e06","670":"d76cabdf","785":"cc11ade7","933":"927a5f2a"}[chunkId] + ".chunk.js";
};